import { customFunctions } from "@/config/customFunction";
import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/Form/FormButtonBox";
import { FormMain } from "@/features/standard/Form/FormMain";
import { FormSelect } from "@/features/standard/Form/FormSelect";
import { FormWrapper } from "@/features/standard/Form/FormWrapper";
import customAlert from "@/features/ui/alert/alert";
import { getPrinterCodeByUserWithWhoami } from "@/utils/checkData";
import { Button, Flex, Text, TextInput } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { WorksWorkIdPerformancePut200Response } from "@sizlcorp/sizl-api-document/dist/models";
import axios from "axios";
import { useTranslation } from "react-i18next";

const BarcodeSlitting = Object.assign(FormMain, {
  Button: Button,
  Input: TextInput,
  Select: FormSelect,
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
  Text: Text,
  Flex: Flex,
  DateInput: DateInput,
});

interface BarcodeSlittingFormProps {
  data: WorksWorkIdPerformancePut200Response[];
}

export const BarcodeSlittingForm = ({ data }: BarcodeSlittingFormProps) => {
  const { closeModal } = useModal();

  const { t } = useTranslation();

  const onSubmit = async () => {
    try {
      const lotIds = data
        .map((work) => work.end?.progress?.[0].incoming?.lotData?.id)
        .filter((id): id is number => id !== undefined);
      const itemCodes = data
        .map((work) => work.end?.progress?.[0].incoming?.itemData?.code)
        .filter((code): code is string => code !== undefined);
      const locationCodes = data
        .map((work) => work?.end?.progress?.[0].incoming?.locationCode)
        .filter((code): code is string => code !== undefined);
      const quantities = data
        .map((work) => work.workLog?.quantity)
        .filter((qty): qty is string => qty !== undefined);

      await axios
        .post(
          `${customFunctions.ADD_COMPANY_BARCODE_ADDRESS_INVENTORY}`,
          {
            company_code: process.env.REACT_APP_COMPANY_CODE,
            lot_id: lotIds,
            printer_code: await getPrinterCodeByUserWithWhoami(),
            quantity: quantities,
            location_code: locationCodes,
            item_code: itemCodes,
          },
          { headers: { "Content-Type": "application/json" } },
        )
        .then(() =>
          customAlert(t("message.printerSuccess"), t("message.printerSuccessMessage"), "green"),
        )
        .catch(() => customAlert(t("message.printerFail"), t("message.printerFailMessage"), "red"));
      closeModal({});
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <BarcodeSlitting.Wrapper>
        <BarcodeSlitting.Text>{t("barcode.slitting")}</BarcodeSlitting.Text>
        <BarcodeSlitting.ButtonBox>
          <BarcodeSlitting.Button color="red" onClick={closeModal}>
            {t("common.no")}
          </BarcodeSlitting.Button>
          <BarcodeSlitting.Button onClick={onSubmit}>{t("common.yes")}</BarcodeSlitting.Button>
        </BarcodeSlitting.ButtonBox>
      </BarcodeSlitting.Wrapper>
    </>
  );
};
